import RemittanceInstructionListTable from '../components/table/RemittanceInstructionListTable.tsx';
import { Paper } from '@mantine/core';
import { useRemittanceInstructions } from '../hooks/useRemittanceInstructions.ts';
import sortBy from 'lodash.sortby';

const RemittanceInstructionListPage = () => {
  const { data = [], isLoading } = useRemittanceInstructions();

  return (
    <Paper p="xl" radius="lg" shadow="xl" mb="xl">
      <RemittanceInstructionListTable
        data={sortBy(data, 'readyDateTime').reverse()}
        isLoading={isLoading}
      />
    </Paper>
  );
};

export default RemittanceInstructionListPage;
